import { SortDefinition } from '@shared/models/sort-definition';

export interface SiteState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: SiteState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'nom' },
};
